import openSDPWithRoute from '../utils/openSDPWithRoute.js';

export const insertTestDriveCTA = (config = {}) => {
	const { testDriveCtaLabel = 'Test Drive', showTestDriveCta, refreshDsAfterSdpClose, useCustomInsertLocations } = config;

	if (!showTestDriveCta) {
		return;
	}

	const location = useCustomInsertLocations ? 'vehicle-ctas-custom' : 'vehicle-ctas';
	const intent = 'vehicle-test-drive-button';
	const region = document.querySelector(`[data-location="${location}"]`) || document.getElementById(location);

	if (!region) {
		return;
	}

	if (region.querySelector(`[data-cta-intent="${intent}"]`)) {
		return;
	}

	const btn = document.createElement('button');

	btn.type = 'button';
	btn.className = 'btn btn-block btn-default';
	btn.textContent = testDriveCtaLabel;
	btn.setAttribute('data-cta-intent', intent);
	btn.setAttribute('data-cta-location', location);
	btn.addEventListener('click', () => openSDPWithRoute('testDrive', refreshDsAfterSdpClose));
	region.appendChild(btn);
};
